import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import ModalClientContainer_vue_vue_type_script_setup_true_lang_default from "./ModalClientContainer.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                         */
//#region src/v2/components/modals/ModalClientContainer.vue
var ModalClientContainer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ModalClientContainer_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-44c68ca5"]]);
//#endregion
export { ModalClientContainer_default as default };

//# sourceMappingURL=ModalClientContainer.vue.js.map